import { Tab } from '@headlessui/react';
import DatePicker from '../../components/forms/DatePicker/DatePicker';
import Select from '../../components/forms/Select/Select';
import { classNames } from '../../utils/helpers/helpers';
import {
  GRANULARITIES,
  METRICS,
  MODES,
  MODE_TIMELINE,
  SPLITS,
} from './constants';

export default function RegistrationTimelineFilters({
  mode,
  setMode,
  granularity,
  setGranularity,
  metric,
  setMetric,
  split,
  setSplit,
  cumulative,
  setCumulative,
  region,
  setRegion,
  regions,
  selectedSchools,
  setSelectedSchools,
  schools,
  selectedYears,
  setSelectedYears,
  yearOptions,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  singleSchool,
  hideRegion,
}) {
  const selectedMode = Math.max(
    MODES.findIndex((item) => item.value === mode),
    0,
  );

  return (
    <div className='flex flex-col gap-4'>
      <Tab.Group
        manual
        selectedIndex={selectedMode}
        onChange={(index) => setMode(MODES[index].value)}
      >
        <Tab.List className='flex flex-row flex-wrap gap-2'>
          {MODES.map((item) => (
            <Tab
              key={item.value}
              title={item.hint}
              className={({ selected }) =>
                classNames(
                  'rounded-md px-4 py-2',
                  'bg-blue-100',
                  selected
                    ? 'bg-blue-600 text-white'
                    : 'text-blue-600 hover:bg-blue-600 hover:text-white',
                )
              }
            >
              {item.label}
            </Tab>
          ))}
        </Tab.List>
      </Tab.Group>

      <div className='flex flex-col gap-2'>
        <label className='text-sm font-medium text-gray-700'>
          Детализация:
        </label>
        <div className='flex flex-row flex-wrap gap-2'>
          {GRANULARITIES.map((item) => (
            <button
              key={item.value}
              type='button'
              onClick={() => setGranularity(item.value)}
              className={classNames(
                'rounded-md border px-4 py-2 text-sm',
                granularity === item.value
                  ? 'border-primary bg-primary text-white'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-primary',
              )}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className='flex flex-row flex-wrap items-end gap-4'>
        <Select
          className='w-56'
          label='Показатель'
          options={METRICS}
          value={metric}
          onChange={(option) => setMetric(option?.value)}
        />

        {!singleSchool && (
          <Select
            className='w-56'
            label='Разрез'
            options={SPLITS}
            value={split}
            onChange={(option) => setSplit(option?.value)}
          />
        )}

        {!singleSchool && !hideRegion && (
          <Select
            className='w-56'
            label='Регион'
            placeholder='Все регионы'
            options={regions}
            value={region}
            isClearable
            onChange={(option) => setRegion(option?.value ?? null)}
          />
        )}

        {!singleSchool && (
          <Select
            className='w-80'
            label='Школы'
            placeholder='Все школы'
            options={schools}
            value={selectedSchools}
            isMulti
            isSearchable
            closeMenuOnSelect={false}
            onChange={(options) =>
              setSelectedSchools((options ?? []).map((option) => option.value))
            }
          />
        )}

        {mode !== MODE_TIMELINE && (
          <Select
            className='w-56'
            label='Годы'
            placeholder='Все годы'
            options={yearOptions}
            value={selectedYears}
            isMulti
            closeMenuOnSelect={false}
            onChange={(options) =>
              setSelectedYears((options ?? []).map((option) => option.value))
            }
          />
        )}

        {/* There is no range picker in this codebase, so the period is two
            independent bound dates, as on the comparison page. */}
        {mode === MODE_TIMELINE && (
          <>
            <DatePicker
              className='w-44'
              label='Период с:'
              selected={dateFrom}
              onChange={setDateFrom}
              dateFormat='dd.MM.yyyy'
              maxDate={dateTo}
            />
            <DatePicker
              className='w-44'
              label='по:'
              selected={dateTo}
              onChange={setDateTo}
              dateFormat='dd.MM.yyyy'
              minDate={dateFrom}
            />
          </>
        )}

        <label className='flex cursor-pointer items-center gap-2 pb-2'>
          <input
            type='checkbox'
            checked={cumulative}
            onChange={(event) => setCumulative(event.target.checked)}
            className='h-4 w-4 text-blue-600 focus:ring-blue-500'
          />
          <span className='text-sm'>Нарастающим итогом</span>
        </label>
      </div>
    </div>
  );
}
